import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnChanges, OnInit, SimpleChanges, ViewContainerRef, ViewEncapsulation } from "@angular/core";
import { formatNumber } from '@angular/common';
import { SharedService, round } from '../../shared';
import { Options } from 'ngx-slider-v2';
import { TherapieTabsEnum, ITitrationLogParams, TitrationEventType, D_THCKonzentrationFortInput, D_KolbenpipetteValue, D_DosierpumpeValue } from '../titration-rechner.model';

import { TitrationTherapieCommonComponent, DE } from '../therapie-common.component';
import { PartnerNamesEnum } from "../../medizinisches-cannabisantrag";


@Component({
    selector: 'app-titration-therapie-fortsetzen',
    templateUrl: "./therapie-fortsetzen.component.html",
    styleUrls: ["./therapie-fortsetzen.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class TitrationTherapieFortsetzenComponent extends TitrationTherapieCommonComponent implements OnInit, OnChanges {
    ActiveTherapieTab = TherapieTabsEnum.FORTSETZEN;
    expandedRow: boolean = false;

    CAMthcKonzentrationInput: any = D_THCKonzentrationFortInput;
    CAMartDerDorierungInput: any = D_DosierpumpeValue;
    CAMverschreibungsmengeInput: any = 20;

    CamThcKonzentrationList: any[] = [];
    CamArtDerDorierungList: any[] = [];
    CamVerschreibungsmengeList: any[] = [];

    tableDataObj: any = {
        morgens: {
            aktuelleDosierungTHC: 0,
            aktuelleDosierungCBD: 0,
            neueDosierung: 0,
            milliTHC: 0,
            milliCBD: 0,
            milliHube: 0
        },
        mittags: {
            aktuelleDosierungTHC: 0,
            aktuelleDosierungCBD: 0,
            neueDosierung: 0,
            milliTHC: 0,
            milliCBD: 0,
            milliHube: 0
        },
        abends: {
            aktuelleDosierungTHC: 0,
            aktuelleDosierungCBD: 0,
            neueDosierung: 0,
            milliTHC: 0,
            milliCBD: 0,
            milliHube: 0
        },
        zurNacht: {
            aktuelleDosierungTHC: 0,
            aktuelleDosierungCBD: 0,
            neueDosierung: 0,
            milliTHC: 0,
            milliCBD: 0,
            milliHube: 0
        }
    };

    get CAMthcKonzentrationObj() {
        return this.CamThcKonzentrationList.find(a => a.ProductName == this.CAMthcKonzentrationInput)
    }

    get CAMthcKonzArt() {
        //return this.CAMthcKonzentrationObj?.ART || this.CAMthcKonzentrationObj?.ProductName || "Cannabisextrakt";
        return this.CAMthcKonzentrationObj?.ProductName || "Cannabisextrakt";
    }

    get CAMthcMgML() {
        if (this.CAMthcKonzentrationObj && this.CAMthcKonzentrationObj.THC) {
            var THC = this.CAMthcKonzentrationObj.THC;
            if (typeof THC == 'number') {
                return THC;
            }
            return parseInt(THC.match(/\d+/), 10);
        }
        return 0;
    }

    get CAMcbdMgML() {
        if (this.CAMthcKonzentrationObj && this.CAMthcKonzentrationObj.CBD) {
            var CBD = this.CAMthcKonzentrationObj.CBD;
            if (typeof CBD == 'number') {
                return CBD;
            }
            return parseInt(CBD.match(/\d+/), 10);
        }
        return 0;
    }

    get morgensDisplay() {
        return formatNumber(this.morgensVal, DE);
    }

    get mittagsDisplay() {
        return formatNumber(this.mittagsVal, DE);
    }

    get abendsDisplay() {
        return formatNumber(this.abendsVal, DE);
    }

    get zurNachtDisplay() {
        return formatNumber(this.zurNachtVal, DE);
    }

    get dorierungType() {
        return this.artDerDorierungInput == this.KolbenpipetteValue ? 'Milliliter' : 'Hüben';
    }

    get artDdorierungName() {
        return this.artDerDorierungInput == this.KolbenpipetteValue ? 'Kolbenpipette (mL)' : 'Dosierpumpe (Hübe)';
    }

    get CAMdorierungType() {
        return this.CAMartDerDorierungInput == this.KolbenpipetteValue ? 'Milliliter' : 'Hüben';
    }

    get CAMartDdorierungName() {
        return this.artDerDorierungInput == this.KolbenpipetteValue ? 'Kolbenpipette (mL)' : 'Dosierpumpe (Hübe)';
    }

    constructor(protected cd: ChangeDetectorRef,
        protected vcr: ViewContainerRef,
        protected resolver: ComponentFactoryResolver,
        protected sharedService: SharedService) {
        super(cd, vcr, resolver, sharedService);
    }

    fnSetDefaultValues() {
        this.artDerDorierungList = [...this.D_artDerDorierungList];
        this.CamArtDerDorierungList = [...this.D_artDerDorierungList];
        this.CamVerschreibungsmengeList = [...this.D_verschreibungsmengeList];

        let productList = [...this.productList];
        switch (this.partnerName) {
            case PartnerNamesEnum.DOSIS_EQ_TILRAY:
            case PartnerNamesEnum.DOSIS_EQ_HORMOSAN:
            case PartnerNamesEnum.DOSIS_EQ_420_PHARMA:
                this.productList = [
                    ...productList,
                    ...this.D_thcKonzentrationList
                ];
                this.CamThcKonzentrationList = [
                    ...productList,
                    ...this.D_thcKonzentrationList
                ];
                break;
            default:
                this.CamThcKonzentrationList = [...this.D_thcKonzentrationList];
                break;
        }
    }

    ngOnInit(): void {
        this.fnSetDefaultValues();
        this.fnSetDefaultInputParams("ONLOAD");
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (changes.hasOwnProperty(propName)) {
                let change = changes[propName];
                switch (propName) {
                    case 'productNameInput':
                        if (change.previousValue !== change.currentValue) {
                            this.productNameInput = change.currentValue;
                            if (this.productNameInput) {
                                if (change.previousValue) {
                                    this.fnSetDefaultInputParams("PRODUCT");
                                } else {
                                    this.fnSetDefaultInputParams("DEFAULT");
                                }
                            }
                        }
                        break;
                }
            }
        }
    }

    inputChangeProduct() {
        this._inputChangeProduct();
        switch (this.partnerName) {
            case PartnerNamesEnum.DOSIS_EQ_TILRAY:
            case PartnerNamesEnum.DOSIS_EQ_HORMOSAN:
            case PartnerNamesEnum.DOSIS_EQ_420_PHARMA:
                this.CAMthcKonzentrationInput = this.productNameInput;
                this.fnCalculateTable();
                break;
            default:
                break;
        }
    }

    inputChangeTHC() {
        this.fnSaveTitrationLogParamChange("THC Konzentration", this.thcKonzentrationInput);
        this.CAMthcKonzentrationInput = this.thcKonzentrationInput;
        this.fnCalculateTable();
    }

    inputChangeArt() {
        this.fnSaveTitrationLogParamChange("Dosierungsart", this.artDerDorierungInput);
        this.CAMartDerDorierungInput = this.artDerDorierungInput;
        this.updateDosierungsSchemaOptions();
    }

    inputChangeVers() {
        this.fnSaveTitrationLogParamChange("Verschreibungsmenge", this.verschreibungsmengeInput);
        this.CAMverschreibungsmengeInput = this.verschreibungsmengeInput;
        this.fnCalculateTable();

    }

    sliderUserChange(Name: string, Value: any) {
        this.fnSaveTitrationLogParamChange(Name, Value);
        this.fnCalculateTable();
    }

    sliderValueChange() {

    }

    inputChangeCAM(Name: string, Value: any) {
        this.fnSaveTitrationLogParamChange(Name, Value);
        this.fnCalculateTable();
    }

    fnSaveTitrationLogParamChange(Name: string, Value: any) {
        let Params: ITitrationLogParams[] = [];
        Params.push({ Name, Value });
        this.saveTitrationLog(TitrationEventType.ParameterChange, Params);
    }


    updateDosierungsSchemaOptions() {
        if (this.artDerDorierungInput == this.KolbenpipetteValue) {
            this.morgensVal = round(this.morgensVal * 0.05, 2);
            this.mittagsVal = round(this.mittagsVal * 0.05, 2);
            this.abendsVal = round(this.abendsVal * 0.05, 2);
            this.zurNachtVal = round(this.zurNachtVal * 0.05, 2);

        } else {
            this.morgensVal = round(this.morgensVal / 0.05);
            this.mittagsVal = round(this.mittagsVal / 0.05);
            this.abendsVal = round(this.abendsVal / 0.05);
            this.zurNachtVal = round(this.zurNachtVal / 0.05);
        }
        this.fnCalculateTable();
    }


    onIconClick(type: any) {
        switch (type) {
            case 'info':
                this.fnShowRechnerInfoPopup();
                break;
            case 'reload':
                this.fnSetDefaultInputParams("RELOAD");
                break;
        }
    }

    fnSetDefaultInputBasedProduct() {
        if (this.productNameInput) {
            let setupartDerValue = null;
            if (this.partnerName == PartnerNamesEnum.DOSIS_EQ_TILRAY) {
                setupartDerValue = D_KolbenpipetteValue;
            } else {
                setupartDerValue = D_DosierpumpeValue;
            }
            if (this.artDerDorierungList.findIndex(a => a.value == setupartDerValue) >= 0) {
                this.artDerDorierungInput = setupartDerValue;
            } else {
                this.artDerDorierungInput = this.artDerDorierungList[0].value;
            }
            if (this.verschreibungsmengeList.findIndex(a => a.value == 25) >= 0) {
                this.verschreibungsmengeInput = 25;
            } else {
                this.verschreibungsmengeInput = this.verschreibungsmengeList[0].value;
            }

            switch (this.partnerName) {
                case PartnerNamesEnum.DOSIS_EQ_TILRAY:
                case PartnerNamesEnum.DOSIS_EQ_HORMOSAN:
                case PartnerNamesEnum.DOSIS_EQ_420_PHARMA:
                    this.CAMthcKonzentrationInput = this.productNameInput;
                    break;
                default:
                    this.CAMthcKonzentrationInput = this.thcKonzentrationInput;
                    break;
            }
            this.CAMartDerDorierungInput = this.artDerDorierungInput;
            this.CAMverschreibungsmengeInput = this.verschreibungsmengeInput;
        } else {
            this.thcKonzentrationInput = D_THCKonzentrationFortInput;
            if (this.partnerName == PartnerNamesEnum.DOSIS_EQ_TILRAY) {
                this.artDerDorierungInput = D_KolbenpipetteValue;
            } else {
                this.artDerDorierungInput = D_DosierpumpeValue;
            }
            this.verschreibungsmengeInput = 25;

            this.CAMthcKonzentrationInput = this.thcKonzentrationInput;
            this.CAMartDerDorierungInput = this.artDerDorierungInput;
            this.CAMverschreibungsmengeInput = this.verschreibungsmengeInput;
        }
    }

    fnSetDefaultInputParams(type: 'DEFAULT' | 'ONLOAD' | 'RELOAD' | 'PRODUCT') {
        this.fnSetDefaultInputBasedProduct();

        if (this.artDerDorierungInput == this.KolbenpipetteValue) {
            this.morgensVal = 0.3;
            this.mittagsVal = 0;
            this.abendsVal = 0.3;
            this.zurNachtVal = 0;
        } else {
            this.morgensVal = 6;
            this.mittagsVal = 0;
            this.abendsVal = 6;
            this.zurNachtVal = 0;
        }
        this.fnCalculateTable();

        let Params = this.fnGetTitrationLogParams();
        if (type === 'PRODUCT') {
            this.generateTitrationLogParams(TitrationEventType.ProductSelection, Params);
        }
        else {
            let EventType = type === 'ONLOAD' ? TitrationEventType.PageLoad : TitrationEventType.PageReLoad;
            if (this.isShowPreLoadPopup) {
                this.fnShowPreLoadQuestionPopup(EventType, Params);
            } else {
                this.generateTitrationLogParams(EventType, Params);
            }
        }
    }

    fnGetTitrationLogParams() {
        let Params: ITitrationLogParams[] = [];
        Params.push({ Name: "CAM THC Konzentration", Value: this.CAMthcKonzentrationInput });
        Params.push({ Name: "CAM Dosierungsart", Value: this.CAMartDerDorierungInput });
        Params.push({ Name: "CAM Verschreibungsmenge", Value: this.CAMverschreibungsmengeInput });
        return Params;
    }

    fnShowRechnerInfoPopup(accNumber = null) {
        this.fnShowCommonRechnerInfoPopup(accNumber, TherapieTabsEnum.FORTSETZEN);
    }

    fnPrintPageData() {
        let Params = this.fnGetTitrationLogParams();
        this.fnPrintData(Params);
    }

    fnShowRezeptPopup() {
        let Params = this.fnGetTitrationLogParams();
        this.fnShowCommonRezeptPopup(Params, this.getHeaderContent(false));
    }


    getHeaderContent(html = true) {
        if (html) {
            return this.generateHeaderContentProductHTML();
        } else {
            return this.generateHeaderContentProductRezept();
        }
    }

    generateHeaderContentProductHTML() {
        var content = `<p>`;
        content += `${this.CAMthcKonzArt}, `;

        var neueHTML = "";
        if (this.tableDataObj.morgens.neueDosierung != "-") {
            neueHTML += `morgens ${this.tableDataObj.morgens.neueDosierung}`;
        }
        if (this.tableDataObj.mittags.neueDosierung != "-") {
            if (neueHTML.length) {
                neueHTML += ", ";
            }
            neueHTML += `mittags ${this.tableDataObj.mittags.neueDosierung}`;
        }
        if (this.tableDataObj.abends.neueDosierung != "-") {
            if (neueHTML.length) {
                neueHTML += ", ";
            }
            neueHTML += `abends ${this.tableDataObj.abends.neueDosierung}`;
        }
        if (this.tableDataObj.zurNacht.neueDosierung != "-") {
            if (neueHTML.length) {
                neueHTML += ", ";
            }
            neueHTML += `zur Nacht ${this.tableDataObj.zurNacht.neueDosierung}`;
        }
        if (neueHTML.length) {
            content += `orale Einnahme, Dosierung: ${neueHTML} `;
        }
        //content += `(${formatNumber(round(this.getTotalMilliTHC(), 0), DE)} mg THC/Tag`;
        //if (this.getTotalMilliCBD() > 0) {
        //    content += ` und ${formatNumber(round(this.getTotalMilliCBD(), 0), DE)} mg CBD/Tag`;
        //}
        //content += `)`;
        content += `</p><p>`;
        content += `${formatNumber(round(this.getTotalMilliHube(), 2), DE)} `;

        if (this.CAMartDerDorierungInput == this.KolbenpipetteValue) {
            content += `mL`;
        } else {
            content += `Hübe`;
        }
        content += `/Tag, `;
        content += `Verschreibungsmenge ausreichend für ${round(this.CAMverschreibungsmengeInput * this.CAMthcMgML / this.getTotalAktuelleDosierungTHC())} Tage`;
        content += `</p>`;
        return content;
    }

    generateHeaderContentProductRezept() {
        var content = ``;
        content += `${formatNumber(this.CAMverschreibungsmengeInput, DE)} mL ${this.CAMthcKonzArt} mit ${formatNumber(this.CAMthcMgML, DE)} mg THC/mL `;
        if (this.CAMcbdMgML) {
            content += `und ${formatNumber(this.CAMcbdMgML, DE)} mg CBD/mL `;
        }
        //content += `(${formatNumber(round(this.CAMverschreibungsmengeInput * this.CAMthcMgML), DE)} mg THC `;
        //if (this.CAMcbdMgML) {
        //    content += `und ${formatNumber(round(this.CAMverschreibungsmengeInput * this.CAMcbdMgML), DE)} mg CBD `;
        //}
        /*content += `gesamt), `;*/
        content += `, `;

        var neueHTML = "";
        if (this.tableDataObj.morgens.neueDosierung != "-") {
            neueHTML += `morgens ${this.tableDataObj.morgens.neueDosierung}`;
        }
        if (this.tableDataObj.mittags.neueDosierung != "-") {
            if (neueHTML.length) {
                neueHTML += ", ";
            }
            neueHTML += `mittags ${this.tableDataObj.mittags.neueDosierung}`;
        }
        if (this.tableDataObj.abends.neueDosierung != "-") {
            if (neueHTML.length) {
                neueHTML += ", ";
            }
            neueHTML += `abends ${this.tableDataObj.abends.neueDosierung}`;
        }
        if (this.tableDataObj.zurNacht.neueDosierung != "-") {
            if (neueHTML.length) {
                neueHTML += ", ";
            }
            neueHTML += `zur Nacht ${this.tableDataObj.zurNacht.neueDosierung}`;
        }
        if (neueHTML.length) {
            content += `orale Einnahme, >>${neueHTML}<<`;
        }
        //content += `(${formatNumber(round(this.getTotalMilliTHC(), 0), DE)} mg THC/Tag`;
        //if (this.getTotalMilliCBD() > 0) {
        //    content += ` und ${formatNumber(round(this.getTotalMilliCBD(), 0), DE)} mg CBD/Tag`;
        //}
        //content += `)`;
        return content;
    }

    getTotalAktuelleDosierungTHC() {
        return this.tableDataObj.morgens.aktuelleDosierungTHC + this.tableDataObj.mittags.aktuelleDosierungTHC + this.tableDataObj.abends.aktuelleDosierungTHC + this.tableDataObj.zurNacht.aktuelleDosierungTHC;
    }

    getTotalMilliHube() {
        return this.tableDataObj.morgens.milliHube + this.tableDataObj.mittags.milliHube + this.tableDataObj.abends.milliHube + this.tableDataObj.zurNacht.milliHube;
    }

    getTotalMilliTHC(precision = 0) {
        return round(this.tableDataObj.morgens.milliTHC + this.tableDataObj.mittags.milliTHC + this.tableDataObj.abends.milliTHC + this.tableDataObj.zurNacht.milliTHC, precision);
    }

    getTotalMilliCBD(precision = 0) {
        return round(this.tableDataObj.morgens.milliCBD + this.tableDataObj.mittags.milliCBD + this.tableDataObj.abends.milliCBD + this.tableDataObj.zurNacht.milliCBD, precision);
    }

    getTotalMilliTHCFormtted(precision = 0) {
        return formatNumber(this.getTotalMilliTHC(precision), DE);
    }
    getTotalMilliCBDFormtted(precision = 0) {
        return formatNumber(this.getTotalMilliCBD(precision), DE);
    }

    fnResetTableData() {
        this.tableDataObj = {
            morgens: {
                aktuelleDosierungTHC: 0,
                aktuelleDosierungCBD: 0,
                neueDosierung: 0,
                milliTHC: 0,
                milliCBD: 0,
                milliHube: 0
            },
            mittags: {
                aktuelleDosierungTHC: 0,
                aktuelleDosierungCBD: 0,
                neueDosierung: 0,
                milliTHC: 0,
                milliCBD: 0,
                milliHube: 0
            },
            abends: {
                aktuelleDosierungTHC: 0,
                aktuelleDosierungCBD: 0,
                neueDosierung: 0,
                milliTHC: 0,
                milliCBD: 0,
                milliHube: 0
            },
            zurNacht: {
                aktuelleDosierungTHC: 0,
                aktuelleDosierungCBD: 0,
                neueDosierung: 0,
                milliTHC: 0,
                milliCBD: 0,
                milliHube: 0
            }
        };

    }

    fnGetValueForProductType(type, value) {
        if (this.artDerDorierungInput == this.KolbenpipetteValue) {
            this.tableDataObj[type]["aktuelleDosierungTHC"] = value * this.productTHC;
            this.tableDataObj[type]["aktuelleDosierungCBD"] = value * this.productCBD;
            this.tableDataObj[type]["DaktuelleDosierung"] = round(value * this.productTHC, 2)
        } else {
            this.tableDataObj[type]["aktuelleDosierungTHC"] = value * this.DosierpumpeValue * this.productTHC;
            this.tableDataObj[type]["aktuelleDosierungCBD"] = value * this.DosierpumpeValue * this.productCBD;
            this.tableDataObj[type]["DaktuelleDosierung"] = round(value * this.DosierpumpeValue * this.productTHC);
        }

        if (this.tableDataObj[type]["aktuelleDosierungTHC"] > 0) {
            if (this.CAMartDerDorierungInput == this.KolbenpipetteValue) {
                this.tableDataObj[type]["neueDosierung"] = formatNumber(round(round(this.tableDataObj[type]["aktuelleDosierungTHC"] / this.CAMthcMgML / this.KolbenpipetteValue) * this.KolbenpipetteValue, 2), DE) + " mL";
            } else {
                this.tableDataObj[type]["neueDosierung"] = formatNumber(round(this.tableDataObj[type]["aktuelleDosierungTHC"] / this.CAMthcMgML / this.DosierpumpeValue), DE) + " Hübe";
            }
        } else {
            this.tableDataObj[type]["neueDosierung"] = "-";
        }

        if (this.CAMartDerDorierungInput == this.KolbenpipetteValue) {
            this.tableDataObj[type]["milliTHC"] = round(round(this.tableDataObj[type]["aktuelleDosierungTHC"] / this.CAMthcMgML / this.KolbenpipetteValue) * this.KolbenpipetteValue * this.CAMthcMgML, 2);
            this.tableDataObj[type]["milliHube"] = round(round(this.tableDataObj[type]["aktuelleDosierungTHC"] / this.CAMthcMgML / this.KolbenpipetteValue) * this.KolbenpipetteValue, 2);
        } else {
            this.tableDataObj[type]["milliTHC"] = round(round(this.tableDataObj[type]["aktuelleDosierungTHC"] / this.CAMthcMgML, 2) * this.CAMthcMgML, 2);
            this.tableDataObj[type]["milliHube"] = round(this.tableDataObj[type]["aktuelleDosierungTHC"] / this.CAMthcMgML / this.DosierpumpeValue);
        }

        if (this.CAMcbdMgML > 0) {
            if (this.CAMartDerDorierungInput == this.KolbenpipetteValue) {
                this.tableDataObj[type]["milliCBD"] = round(round(this.tableDataObj[type]["aktuelleDosierungTHC"] / this.CAMcbdMgML / this.KolbenpipetteValue) * this.KolbenpipetteValue * this.CAMcbdMgML, 2);
            } else {
                this.tableDataObj[type]["milliCBD"] = round(round(this.tableDataObj[type]["aktuelleDosierungTHC"] / this.CAMcbdMgML, 2) * this.CAMcbdMgML, 2);
            }
        }
    }

    fnCalculateTable() {
        this.fnResetTableData();

        this.fnGetValueForProductType("morgens", this.morgensVal);
        this.fnGetValueForProductType("mittags", this.mittagsVal);
        this.fnGetValueForProductType("abends", this.abendsVal);
        this.fnGetValueForProductType("zurNacht", this.zurNachtVal);
    }
}
